<template>
  <div class="PaB-view-controls">
    <products-sort v-if="!isHome"></products-sort>

    <app-button v-if="!isHome" label="View" :icon="true" type="plain" @click.native="toggleView">
      <template slot="after">
        <icon-base icon-name="Grid" v-if="view === 'list'">
          <icon-grid />
        </icon-base>
        <icon-base icon-name="Row" v-else>
          <icon-list />
        </icon-base>
      </template>
    </app-button>
    <cart-button />
  </div>
</template>

<style lang="scss" scoped>
.PaB-view-controls {
  display: flex;
  flex-direction: row;
  align-content: flex-end;
  position: relative;
  flex: 1 1 120px;
}
</style>

<script>
import ProductsSort from '@/components/ProductsSort'
import Dropdown from '@/components/Dropdown'
import AppButton from '@/components/AppButton'
import CartButton from '@/components/CartButton'
import IconBase from '@/components/IconBase'
import IconGrid from '@/components/icons/IconGrid'
import IconList from '@/components/icons/IconList'

export default {
  components: {
    ProductsSort,
    Dropdown,
    AppButton,
    CartButton,
    IconBase,
    IconGrid,
    IconList
  },

  props: ['isHome'],

  computed: {
    view () {
      return this.$store.state.products.view
    }
  },

  methods: {
    toggleView: function () {
      this.$store.dispatch('products/toggleView')
    }
  }
}
</script>
